export default __webpack_public_path__ + "assets/late-clock-red.547ab3ac.svg";